import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const brand = {
  createBrand: lazyModuleMethod(() => import('./createBrand'), 'default'),
  fetchBrand: lazyModuleMethod(() => import('./fetchBrand'), 'default'),
  fetchBrands: lazyModuleMethod(() => import('./fetchBrands'), 'default'),
  searchBrands: lazyModuleMethod(() => import('./searchBrands'), 'default'),
  updateBrand: lazyModuleMethod(() => import('./updateBrand'), 'default'),
}
